import script from "./MdPopover.vue?vue&type=script&lang=js"
export * from "./MdPopover.vue?vue&type=script&lang=js"

import "./MdPopover.vue?vue&type=style&index=0&id=60349f16&lang=scss"

const __exports__ = script;

export default __exports__